<template>
    <div>
        <b-row v-if="loading">
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-4"
                />
            </b-col>
        </b-row>
        <div v-if="!loading" style="padding-bottom: 25px">
            <b-row class="mb-3 mt-2">
                <b-col md="3">
                    <b-row>
                        <b-col md="2">
                            <b-button
                                size="sm"
                                @click="backButton"
                                class="mr-2 my-0 main-navigation-button"
                                variant="light"
                            >
                                <i
                                    class="fa fa-arrow-left"
                                    aria-hidden="false"
                                ></i>
                            </b-button>
                        </b-col>
                        <b-col md="10" class="">
                            <h1
                                class="h5-text"
                                style="font-size: 16px; line-height: 13px"
                            >
                                Order
                                <span class="order-color"
                                    >#{{ mainOrderObject.orderId }}</span
                                >
                            </h1>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="3">
                    <div class="d-flex justify-content-center">
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus ===
                                'Processing'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Processing'
                                        ? 'processing'
                                        : 'pill-alignment  span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus === 'Created'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Created'
                                        ? 'created'
                                        : 'pill-alignment  span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus === 'Returned'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Returned'
                                        ? 'returned'
                                        : 'pill-alignment  span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus ===
                                'Cancelled'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Cancelled'
                                        ? 'cancelled'
                                        : 'pill-alignment  span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus ===
                                'Delivered'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Delivered'
                                        ? 'delivered'
                                        : 'pill-payment-status span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus ===
                                'Confirmed'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Confirmed'
                                        ? 'pill-payment-status'
                                        : 'pill-alignment  span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div
                            v-if="
                                this.orderDetailsData.orderStatus ===
                                'Dispatched'
                            "
                        >
                            <span
                                v-bind:class="
                                    this.orderDetailsData.orderStatus ===
                                    'Dispatched'
                                        ? 'dispatched'
                                        : 'pill-alignment  span-text-pill'
                                "
                                class="pill-alignment pill-payment-status"
                                >{{ this.orderDetailsData.orderStatus }}</span
                            >
                        </div>
                        <div>
                            <span
                                class="item-type pill-alignment pill-payment-status"
                                >{{
                                    this.orderDetailsData.type | formateString
                                }}</span
                            >
                        </div>
                        <!-- <div v-if="this.orderDetailsData.isSelfPickUp" class="">
              <span class="self-pick pill-alignment pill-payment-status">
                Self PickUp
              </span>
            </div>
            <div v-else>
              <span class="pill-alignment pill-payment-status not-selfpick">
                Delivery
              </span>
            </div> -->
                    </div>
                </b-col>
                <b-col>
                    <i class="fa fa-calendar span-text" aria-hidden="false">
                        &nbsp;<span>
                            {{
                                this.orderDetailsData.createdAt | formatedate
                            }}</span
                        >
                    </i>
                </b-col>
                <b-col md="3">
                    <b-button
                        size="md"
                        style="font-size: 14px; float: right; width: 50%"
                        variant="primary"
                        @click="updateOrderModal"
                        v-if="this.orderDetailsData.orderStatus != 'Cancelled'"
                    >
                        Update Order
                    </b-button>
                    <ValidationObserver ref="observer">
                        <b-modal
                            title="Update Order"
                            id="dateRange"
                            size="md"
                            class="heading"
                            ref="update-order-modal"
                            centered
                            hide-header-close
                            hide-footer
                        >
                            <b-row class="p-3">
                                <b-col md="6">
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Status type"
                                        :key="resetKey"
                                    >
                                        <eb-select
                                            style="color: black"
                                            placeholder="Select Status type"
                                            label="text"
                                            type="text"
                                            v-model="selectedStatus"
                                            :selected="selectedStatus"
                                            :options="filteredStatusList"
                                        >
                                        </eb-select>
                                        <span
                                            class="validate-error"
                                            style="color: red"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </b-col>
                                <b-col md="6">
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Delivery agent"
                                        :key="resetKey"
                                    >
                                        <eb-select
                                            placeholder="Select Delivery Agent"
                                            label="text"
                                            type="text"
                                            v-model="selectedAgent"
                                            :selected="selectedAgent"
                                            :options="statusAgentList"
                                        >
                                        </eb-select>
                                        <span
                                            class="validate-error"
                                            style="color: red"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </b-col>
                                <b-col md="6">
                                    <h5>Update ETA :</h5>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="ETA"
                                        :key="resetKey"
                                    >
                                        <b-input
                                            style="margin-bottom: 14px"
                                            type="date"
                                            v-model="etaDate"
                                        >
                                        </b-input>
                                        <span
                                            class="validate-error"
                                            style="color: red"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </b-col>
                                <b-col md="6">
                                    <h5>Update Delivery Time :</h5>
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Delivery time"
                                        :key="resetKey"
                                    >
                                        <b-input
                                            class="mb-3"
                                            type="time"
                                            placeholder="Delivery Time"
                                            v-model="etaTime"
                                        >
                                        </b-input>
                                        <span
                                            class="validate-error"
                                            style="color: red"
                                            >{{ errors[0] }}</span
                                        >
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                            <div class="text-center mt-2">
                                <b-button
                                    @click="hideOrderUpdateModal"
                                    class="my-0 main-navigation-button w-47 mr-2"
                                    variant="danger"
                                    >Cancel
                                </b-button>
                                <b-button
                                    @click="updateOrderStatusButton"
                                    class="my-0 main-navigation-button w-47 mr-2"
                                    variant="primary"
                                    >Update
                                </b-button>
                            </div>
                        </b-modal>
                    </ValidationObserver>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="8">
                    <h1 class="ml-1 mb-3 table-heading">
                        Ordered Item {{ `(${this.itemsCount})` }}
                    </h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="8">
                    <b-row>
                        <b-col>
                            <!-- <h1 class="table-heading">
                Ordered Item {{ `(${this.itemsCount})` }}
              </h1> -->
                            <b-table
                                class="boxstyle"
                                style="margin-bottom: 0px; text-align: center"
                                :dark="false"
                                :hover="false"
                                :striped="false"
                                :bordered="false"
                                :small="false"
                                :fixed="false"
                                :fields="fields"
                                responsive
                                :items="itemTable"
                                thead-class="header"
                                show-empty
                                :no-border-collapse="true"
                            >
                                <template
                                    slot="cell(imageLink)"
                                    slot-scope="data"
                                >
                                    <div>
                                        <img
                                            style="height: 50px"
                                            :src="data.item.imageLink"
                                            alt="Not Available"
                                        />
                                    </div>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div style="float: right; padding: 20px 0px">
                                <b-pagination
                                    v-model="currentPage"
                                    :per-page="perPage"
                                    :total-rows="totalRows"
                                    aria-controls="my-table"
                                    prev-text="Prev"
                                    next-text="Next"
                                    @change="paginationClick"
                                    hide-goto-end-buttons
                                ></b-pagination>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="boxstyle px-3 py-1 mb-2">
                                <h4>Seller Details</h4>
                                <div
                                    v-if="
                                        this.orderDetailsData.provider &&
                                        this.orderDetailsData.provider
                                            .authentication
                                    "
                                    class="mt-3"
                                >
                                    <h5 class="h5-text mb-2">
                                        Seller Name :
                                        <span class="span-text">
                                            {{
                                                this.orderDetailsData.provider
                                                    .authentication.userName
                                            }}</span
                                        >
                                    </h5>
                                    <h5 class="h5-text mb-2">
                                        Address :
                                        <span class="span-text">
                                            {{
                                                (provideAaddressDetail &&
                                                    provideAaddressDetail.city) ||
                                                ""
                                            }},
                                            {{
                                                (provideAaddressDetail &&
                                                    provideAaddressDetail.state) ||
                                                ""
                                            }},
                                            {{
                                                (provideAaddressDetail &&
                                                    provideAaddressDetail.country) ||
                                                ""
                                            }},
                                            {{
                                                (provideAaddressDetail &&
                                                    provideAaddressDetail.zip) ||
                                                ""
                                            }}
                                        </span>
                                    </h5>
                                    <h5 class="h5-text mb-2">
                                        Phone :
                                        <span class="span-text">
                                            {{
                                                this.orderDetailsData.provider
                                                    .authentication.phone
                                            }}
                                        </span>
                                    </h5>
                                    <h5 class="h5-text mb-2">
                                        Email :
                                        <span class="span-text">
                                            {{
                                                this.orderDetailsData.provider
                                                    .authentication.email
                                            }}
                                        </span>
                                    </h5>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="boxstyle px-3 py-1 mb-2">
                                <b-row class="mt-2">
                                    <b-col md="3">
                                        <h4>Payment Summary</h4>
                                    </b-col>
                                    <b-col md="2">
                                        <span
                                            class="pill-payment-status pill-alignment text-center"
                                            >{{
                                                (orderPaymentStatus &&
                                                    orderPaymentStatus[0] &&
                                                    orderPaymentStatus[0]
                                                        .status) ||
                                                ""
                                            }}</span
                                        >
                                    </b-col>
                                    <b-col md="3">
                                        <span
                                            class="pill-payment-status pill-paymentType pill-alignment"
                                            >{{
                                                orderDetailsData.paymentType
                                            }}</span
                                        >
                                    </b-col>
                                </b-row>

                                <b-row class="m-0">
                                    <b-col class="px-0 py-0">
                                        <h4>Sub-Total</h4>
                                        <h4>Shipping</h4>
                                        <!-- <h4 v-for="(gst, count) in gstCalculation" :key="count">
                      {{ gst.type }} @ {{ gst.percent }} %
                    </h4> -->
                                        <h4>Total Taxes</h4>
                                    </b-col>
                                    <b-col class="px-0 py-0">
                                        <h4 class="align-right">
                                            ₹
                                            {{ subTotal }}
                                        </h4>
                                        <h4 class="shipping-charge align-right">
                                            ₹
                                            {{ shippingAmount }}
                                        </h4>
                                        <!-- <h4
                      class="align-right"
                      v-for="(gst, count) in gstCalculation"
                      :key="count"
                    >
                      ₹
                      {{
                        (gst && gst.taxAmount && gst.taxAmount.toFixed(2)) ||
                        "0.00"
                      }}
                    </h4> -->
                                        <h4 class="align-right">
                                            ₹
                                            {{ totalTaxesCount }}
                                        </h4>
                                    </b-col>
                                </b-row>
                                <hr />
                                <div>
                                    <b-row class="mt-n3">
                                        <b-col>
                                            <h3 class="totalPrice">Total</h3>
                                        </b-col>
                                        <b-col class="align-right">
                                            <h3 class="totalPrice">
                                                ₹
                                                {{ totalOrderAmount }}
                                            </h3>
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="boxstyle px-3 py-1">
                                <h4>Order Activity</h4>
                                <h5
                                    class="h5-text mb-3"
                                    v-for="(track, index) in this
                                        .orderDetailsData.reportStatusHistory"
                                    :key="index"
                                    style="margin: 0px"
                                >
                                    <div
                                        :class="{
                                            dot: track.label != 'Cancelled',
                                            cancelledDot:
                                                track.label == 'Cancelled',
                                        }"
                                    ></div>
                                    <span>{{ track.label }}</span>
                                    <div
                                        v-if="track.label != 'Cancelled'"
                                        :class="{
                                            verticalLine:
                                                track.label != 'Delivered',
                                            deliveredLine:
                                                track.label == 'Delivered',
                                        }"
                                    >
                                        <span class="card-span-text px-3">
                                            {{ track.message }}&nbsp;{{
                                                track.time
                                            }}</span
                                        >
                                    </div>
                                    <div
                                        v-if="track.label == 'Cancelled'"
                                        :class="{
                                            verticalLine:
                                                track.label != 'Cancelled',
                                            deliveredLine:
                                                track.label == 'Cancelled',
                                        }"
                                    >
                                        <span class="card-span-text px-3">
                                            {{ track.message }}&nbsp;{{
                                                track.time
                                            }}</span
                                        >
                                    </div>
                                </h5>
                                <div
                                    style="margin: 0px 3px 0px 0px"
                                    v-if="
                                        this.orderDetailsData.orderStatus !=
                                            'Delivered' &&
                                        this.orderDetailsData.orderStatus !=
                                            'Cancelled'
                                    "
                                >
                                    <div class="lastDot"></div>
                                    <span>Order Delivery Pending</span>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col md="4">
                    <b-row>
                        <b-col>
                            <div class="boxstyle px-3 py-1">
                                <h4>Customer</h4>
                                <div
                                    v-if="isAddressAdded"
                                    style="background-color: #ffffff"
                                >
                                    <h5
                                        class="h5-text mt-3"
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <i
                                            class="fa fa-user fa-2x"
                                            aria-hidden="false"
                                        ></i
                                        >&nbsp;&nbsp;
                                        <span class="card-span-text">
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.fullName) ||
                                                ""
                                            }}
                                        </span>
                                    </h5>
                                    <hr />
                                    <h5
                                        class="h5-text mt-3"
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <i
                                            class="fa fa-list fa-lg"
                                            aria-hidden="false"
                                        ></i
                                        >&nbsp;&nbsp;
                                        <span
                                            v-if="orderCount[0].totalCount > 1"
                                            class="card-span-text"
                                            >{{
                                                (orderCount &&
                                                    orderCount[0].totalCount) ||
                                                ""
                                            }}
                                            Orders
                                        </span>
                                        <span v-else>
                                            {{
                                                (orderCount &&
                                                    orderCount[0].totalCount) ||
                                                ""
                                            }}
                                            Order
                                        </span>
                                    </h5>
                                    <hr />
                                    <h4 class="py-1">Contact Info</h4>
                                    <h5 class="h5-text">
                                        <i
                                            class="fa fa-envelope"
                                            aria-hidden="false"
                                        ></i
                                        >&nbsp;
                                        <span
                                            class="span-text"
                                            style="word-wrap: break-word"
                                        >
                                            {{
                                                (contactByEmail &&
                                                    contactByEmail[0] &&
                                                    contactByEmail[0].value) ||
                                                ""
                                            }}
                                        </span>
                                    </h5>
                                    <h5 class="h5-text">
                                        <i
                                            class="fa fa-phone"
                                            aria-hidden="false"
                                        ></i
                                        >&nbsp;
                                        <span
                                            class="span-text"
                                            style="
                                                word-wrap: break-word;
                                                line-height: 1;
                                            "
                                        >
                                            {{
                                                (contactByPhone &&
                                                    contactByPhone[0] &&
                                                    contactByPhone[0].value) ||
                                                ""
                                            }}
                                        </span>
                                    </h5>
                                    <hr />

                                    <div
                                        v-if="orderObject.isSelfPickUp == true"
                                    >
                                        <h4>Pickup Address</h4>
                                        <h5 class="h5-text">
                                            Store Name :
                                            <span class="card-span-text">
                                                {{
                                                    (pickUpAddress &&
                                                        pickUpAddress.name) ||
                                                    ""
                                                }}</span
                                            >
                                        </h5>
                                        <h5 class="h5-text">
                                            Pickup Address :
                                            <span class="card-span-text">
                                                {{
                                                    (pickUpAddress &&
                                                        pickUpAddress.address &&
                                                        pickUpAddress.address
                                                            .City) ||
                                                    ""
                                                }}
                                                {{
                                                    (pickUpAddress &&
                                                        pickUpAddress.address &&
                                                        pickUpAddress.address
                                                            .State) ||
                                                    ""
                                                }}
                                                {{
                                                    (pickUpAddress &&
                                                        pickUpAddress.address &&
                                                        pickUpAddress.address
                                                            .Country) ||
                                                    ""
                                                }}
                                            </span>
                                        </h5>
                                        <h5 class="h5-text">
                                            Phone :
                                            <span class="card-span-text">
                                                {{
                                                    (pickUpAddress &&
                                                        pickUpAddress.phone) ||
                                                    ""
                                                }}</span
                                            >
                                        </h5>
                                        <hr />
                                        <h4>Order Pickup Time</h4>
                                        <span>
                                            <i
                                                class="fa fa-calendar span-text"
                                                aria-hidden="false"
                                            >
                                                &nbsp;<span>
                                                    {{
                                                        (pickupAndDeliveryTime &&
                                                            pickupAndDeliveryTime.time) ||
                                                        "" | formatedate
                                                    }}</span
                                                >
                                            </i>
                                        </span>
                                    </div>

                                    <div v-else>
                                        <h4>Delivery Address</h4>
                                        <h5>
                                            <span
                                                class="span-text"
                                                style="
                                                    line-height: 20px;
                                                    word-wrap: break-word;
                                                "
                                            >
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.fullName) ||
                                                    ""
                                                }}<br />
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.houseNumber) ||
                                                    ""
                                                }}
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.street1) ||
                                                    ""
                                                }}
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.street2) ||
                                                    ""
                                                }}<br />
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.city) ||
                                                    ""
                                                }}-
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.zip) ||
                                                    ""
                                                }}<br />
                                                {{
                                                    (deliveryAaddressDetail &&
                                                        deliveryAaddressDetail.state) ||
                                                    ""
                                                }}<br />
                                                {{
                                                    (contactByPhone &&
                                                        contactByPhone.value) ||
                                                    ""
                                                }}
                                            </span>
                                        </h5>
                                        <hr />
                                        <h4>Billing Address</h4>
                                        <span
                                            class="span-text"
                                            style="word-wrap: break-word"
                                        >
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.fullName) ||
                                                ""
                                            }}<br />
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.houseNumber) ||
                                                ""
                                            }}
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.street1) ||
                                                ""
                                            }}
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.street2) ||
                                                ""
                                            }}<br />
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.city) ||
                                                ""
                                            }}-
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.zip) ||
                                                ""
                                            }}<br />
                                            {{
                                                (deliveryAaddressDetail &&
                                                    deliveryAaddressDetail.state) ||
                                                ""
                                            }}<br />
                                            {{
                                                (contactByPhone &&
                                                    contactByPhone.value) ||
                                                ""
                                            }}
                                        </span>
                                        <hr />
                                        <b-row>
                                            <b-col>
                                                <h4>Order Created Date</h4>
                                                <span>
                                                    <i
                                                        class="fa fa-calendar span-text"
                                                        aria-hidden="false"
                                                    >
                                                        &nbsp;<span
                                                            class="created-time"
                                                        >
                                                            {{
                                                                this
                                                                    .orderDetailsData
                                                                    .createdAt
                                                                    | formatedate
                                                            }}</span
                                                        >
                                                    </i>
                                                </span>
                                            </b-col>
                                        </b-row>
                                        <div v-if="pickupAndDeliveryTime">
                                            <h4>Estimated Delivery Time</h4>
                                            <span>
                                                <i
                                                    class="fa fa-calendar span-text"
                                                    aria-hidden="false"
                                                >
                                                    &nbsp;<span
                                                        class="estimated-time"
                                                    >
                                                        {{
                                                            (pickupAndDeliveryTime &&
                                                                pickupAndDeliveryTime.time) ||
                                                            "" | formatedate
                                                        }}</span
                                                    >
                                                </i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>

                    <button
                        type="button"
                        class="button-invoice mt-2 btn btn-block"
                        @click="viewInvoice"
                    >
                        VIEW INVOICE
                    </button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import ebSelect from "@/components/FormElements/Select.vue";
import currentUserData from "@/mixins/currentUser";
import { AtomSpinner } from "epic-spinners";
import cInput from "@/components/Common/CustomInput";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";
import { mapGetters, mapState } from "vuex";
export default {
    name: "OrderDetails",
    mixins: [currentUserData],
    components: {
        ebButton,
        AtomSpinner,
        ebSelect,
        cInput,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            itemsCount: 0,
            detailsData: [],
            orderObject: {},
            currentPage: 1,
            loading: false,
            perPage: 5,
            totalRows: 0,
            selectedStatus: "",
            selectedAgent: "",
            referenceValue: "",
            etaDate: "",
            etaTime: "",
            pickUpTime: "",
            selectedDeliveryAgent: "",
            resetKey: 0,
            statusList: [
                {
                    text: "Dispatched",
                    value: "Dispatched",
                },
                {
                    text: "Delivered",
                    value: "Delivered",
                },
                {
                    text: "Cancelled",
                    value: "Cancelled",
                },
                {
                    text: "Returned",
                    value: "Returned",
                },
                {
                    text: "Refund",
                    value: "Refund",
                },
            ],
        };
    },
    methods: {
        async paginationClick(e) {
            this.currentPage = e;
        },
        updateOrderModal() {
            this.resetKey++;
            this.etaDate = "";
            this.etaTime = "";
            this.selectedStatus = "";
            this.selectedAgent = "";
            this.$refs["update-order-modal"].show();
        },
        hideOrderUpdateModal() {
            this.resetKey++;
            this.$refs["update-order-modal"].hide();
        },
        updateOrderStatus(e) {
            this.selectedStatus = e;
        },
        updateAgent(e) {
            this.selectedAgent = e;
        },
        backButton() {
            this.$router.push({ path: "/manage-order" });
        },
        updateDeliveryAgent() {
            {
                let payload = {
                    deliveryAgent: {
                        id: this.selectedDeliveryAgent?.value?._id,
                        isAttached: true,
                        name: this.selectedDeliveryAgent?.value?.name,
                        phone: this.selectedDeliveryAgent?.value?.phone,
                    },
                    orderId: this.orderDetailsData.orderId,
                    fullfillmentId: this.orderDetailsData.fullfillmentId,
                };
                try {
                    this.$store.dispatch("order/setDeliveryAgent", payload);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                }
            }
        },
        async updateOrderStatusButton() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;

            let dataObj = {
                actionCode: 20,
                conditions: {
                    orderId: this.orderDetailsData.orderId,
                    isRunning: true,
                    fullfillmentId: this.orderDetailsData.fullfillmentId,
                },
                set: {
                    orderStatus: this.selectedStatus.value,
                    deliveryAgent: this.selectedAgent.value,
                    reportStatus: this.selectedStatus.value,
                },
                push: {
                    reportStatusHistory: {
                        label: this.selectedStatus.value,
                        message: `Your order is ${this.selectedStatus.value}`,
                    },
                },
            };
            if (this.selectedStatus.value === "Returned") {
                dataObj.set["orderReturn"] = {
                    shippingRef: this.referenceValue,
                    shippingService: "",
                };
            } else if (this.selectedStatus.value === "Refund") {
                dataObj.set["orderReturn"] = {
                    refundAmt: this.referenceValue,
                };
            }
            this.$store
                .dispatch("order/updatePickupTime", dataObj)
                .then((res) => {
                    this.$swal({
                        title: "Updated!",
                        text: "Order status is Updated Successfully!",
                        type: "success",
                    });
                });
            this.$refs["update-order-modal"].hide();
            this.fetchOrderDetail();
            // this.$router.push({
            //   path: "/manage-order",
            // });
        },

        UpdatePickupTime() {
            const dataObj = {
                actionCode: 2,
                conditions: {
                    orderId: this.orderDetailsData.orderId,
                    isRunning: true,
                    fullfillmentId: this.orderDetailsData.fullfillmentId,
                },
                set: {
                    etaInMins: this.etaTime,
                    pickUpTime: this.pickUpTime,
                },
            };

            this.$store
                .dispatch("order/updatePickupTime", dataObj)
                .then((res) => {
                    this.$swal({
                        title: "Updated!",
                        text: "ETA & Pickup Time is Updated Successfully!",
                        type: "success",
                    });
                    this.ETATime = "";
                    this.pickUpTime = "";
                });
        },
        async viewInvoice() {
            let orderNumberId = this.orderDetailsData.orderId;
            let order_Id = this.orderDetailsData._id;
            await this.$store.dispatch("order/fetchInvoiceData", orderNumberId);
            if (this.$router.history.current.name === "OrderDetail") {
                this.$router.push({
                    name: "order-invoice",
                    params: {
                        id: orderNumberId,
                        orderId: this.$route.params.orderId,
                    },
                });
            } else {
                this.$router.push({
                    name: "order-invoice",
                    params: {
                        id: orderNumberId,
                        orderId: this.$route.params.orderId,
                    },
                });
            }
        },
    },

    computed: {
        ...mapGetters({
            getOrderCount: "customerManagement/GetOrderGraph",
            getAgentList: "tenant/GetTenantSubAdminList",
            partnerAllData: "partner/GetPartnerData",
        }),
        ...mapState({
            orderDetailsData: (state) => state.order.orderDetailsData,
        }),
        statusAgentList() {
            const data = this.getAgentList.map((e) => {
                return {
                    text: e.name.first,
                    value: e.name.first,
                };
            });
            const unique = [
                ...new Map(data.map((item) => [item.text, item])).values(),
            ];
            return unique;
        },
        filteredStatusList() {
            const currentStatus = this.orderDetailsData.orderStatus;
            if (currentStatus === "Dispatched") {
                return this.statusList.filter(
                    (status) => status.value !== "Dispatched",
                );
            }
            if (currentStatus === "Delivered") {
                return this.statusList.filter(
                    (status) =>
                        status.value !== "Delivered" &&
                        status.value !== "Dispatched" &&
                        status.value !== "Cancelled",
                );
            }
            if (currentStatus === "Refund") {
                return this.statusList.filter(
                    (status) =>
                        status.value !== "Dispatched" &&
                        status.value !== "Delivered" &&
                        status.value !== "Cancelled" &&
                        status.value !== "Refund",
                );
            }
            if (currentStatus === "Returned") {
                return this.statusList.filter(
                    (status) =>
                        status.value !== "Dispatched" &&
                        status.value !== "Delivered" &&
                        status.value !== "Cancelled" &&
                        status.value !== "Returned",
                );
            }
            return this.statusList;
        },

        subTotal() {
            let subTotalAmont =
                this.orderDetailsData.orderAmount -
                this.orderDetailsData.deliveryCharges -
                this.getTotalTax;
            return subTotalAmont?.toFixed(2);
        },
        totalOrderAmount() {
            let totalAmount = this.orderDetailsData.orderAmount;
            return totalAmount?.toFixed(2);
        },
        shippingAmount() {
            let shippingCost = this.orderDetailsData.deliveryCharges;
            return shippingCost?.toFixed(2);
        },
        orderCount() {
            let allOrders = this.getOrderCount?.response?.filter(
                (numberOfOrders) => numberOfOrders.totalCount > 0,
            );
            return allOrders || 0;
        },
        itemTable() {
            if (this.orderDetailsData.modeOfSale === "OFFLINE") {
                if (this.orderDetailsData.items) {
                    const itemsData = this.orderDetailsData.items;
                    let itemInfo = [];
                    if (Array.isArray(itemsData) && itemsData.length > 0) {
                        itemsData.map((obj) => {
                            let arrayObj = {
                                imageLink: obj.product_summary.images.icon,
                                name: obj.string_attributes.map((e) => {
                                    if (e.attribute_name == "Name") {
                                        return e.attribute_value;
                                    }
                                }),
                                qty: obj.Quantity,
                                unitPrice: obj.Price,
                                price: obj.Price,
                            };
                            itemInfo.push(arrayObj);
                        });
                    }
                    return itemInfo;
                }
            } else if (this.orderDetailsData.items) {
                const itemsData = this.orderDetailsData.items;
                this.itemsCount = itemsData.length;
                if (this.currentPage) {
                    this.totalRows = itemsData.length;
                    return itemsData.slice(
                        (this.currentPage - 1) * this.perPage,
                        this.currentPage * this.perPage,
                    );
                }
                // return itemsData;
            } else {
                return [];
            }
        },
        fields() {
            const caption = [
                {
                    key: "imageLink",
                    label: "Image",
                },
                {
                    key: "name",
                    label: "Item",
                },
                {
                    key: "price",
                    label: "Unit Price",
                },
                {
                    key: "qty",
                    label: "No of Units",
                },
                {
                    key: "totalTaxes",
                    label: "Tax Amount",
                },

                {
                    key: "finalPrice",
                    label: "Total Price",
                },
            ];
            return caption;
        },
        getTotalTax() {
            let totalTax = 0;
            try {
                this.gstCalculation.forEach((obj) => {
                    totalTax = totalTax + obj.taxAmount;
                });
                return totalTax;
            } catch {
                return totalTax;
            }
        },
        gstCalculation() {
            if (this.isItemAdded) {
                let taxCalculate = [];
                this.orderDetailsData.items?.forEach((obj) => {
                    taxCalculate.push(...obj.taxes);
                });
                return taxCalculate;
            } else {
                return {};
            }
        },
        totalTaxesCount() {
            if (this.isItemAdded) {
                let totalTax = 0;
                this.orderDetailsData.items?.forEach((obj) => {
                    totalTax = totalTax + obj.totalTaxes;
                });
                return totalTax?.toFixed(2);
            } else {
                return {};
            }
        },
        isItemAdded() {
            if (
                this.orderDetailsData.items &&
                this.orderDetailsData.items !== undefined
            ) {
                return true;
            } else {
                return false;
            }
        },
        // isOfficeAdded() {
        //   if (
        //     this.detailsData.provider.office &&
        //     this.detailsData.provider.office.address
        //   ) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // },
        isAddressAdded() {
            if (
                this.orderDetailsData.deliveryAddress &&
                this.orderDetailsData.deliveryAddress.address !== undefined
            ) {
                return true;
            } else {
                return false;
            }
        },
        orderList() {
            if (this.$userRole === "Partner") {
                if (this.userCategory === "MANUFACTURER") {
                    return this.$store.getters["order/GetListOrderAllUsers"];
                } else {
                    return this.$store.getters["order/GetListOrderAllUsers"];
                }
            } else {
                return this.$store.getters["order/GetListOrderAllUsers"];
            }
        },
        pickUpAddress() {
            return this.orderDetailsData.deliveryAddress;
        },
        mainOrderObject() {
            if (this.orderDetailsData) {
                return this.orderDetailsData;
            } else {
                return {};
            }
        },
        // providerDetails() {
        //   let data = this.$store.getters["partner/GetPartnerDetailsById"];
        //   try {
        //     if (data._id) {
        //       return data;
        //     } else {
        //       return {};
        //     }
        //   } catch {
        //     return {};
        //   }
        // },
        provideAaddressDetail() {
            if (this.orderDetailsData?.provider.office) {
                return this.orderDetailsData?.provider.office?.address || "";
            }
        },
        orderPaymentStatus() {
            if (this.orderDetailsData) {
                let paymentStatus =
                    this.orderDetailsData.payments?.items?.filter(
                        (orderStatus) =>
                            Object.keys(orderStatus).includes("status") || "",
                    );
                return paymentStatus;
            }
        },
        contactByEmail() {
            if (this.orderDetailsData) {
                return this.orderDetailsData?.deliveryAddress?.address?.contacts?.filter(
                    (emailAddress) =>
                        emailAddress.contactType == "PRIMARY_EMAIL",
                );
            }
        },
        contactByPhone() {
            if (this.orderDetailsData) {
                return this.orderDetailsData?.deliveryAddress?.address?.contacts?.filter(
                    (emailAddress) =>
                        emailAddress.contactType == "PRIMARY_PHONE",
                );
            }
        },
        pickupAndDeliveryTime() {
            if (this.orderDetailsData) {
                let receiveTime =
                    this.orderDetailsData?.reportStatusHistory?.find((time) => {
                        if (Object.values(time).includes("Approved")) {
                            return time;
                        }
                    });
                return receiveTime;
            }
        },
        deliveryAaddressDetail() {
            if (this.orderDetailsData) {
                return this.orderDetailsData?.deliveryAddress?.address;
            }
        },
        async fetchOrderDetail() {
            this.loading = true;
            await this.$store.dispatch(
                "order/getOrderDetails",
                this.$route.params.orderId,
            );
            const payload = {
                customerId: this.orderDetailsData.customer?._id,
                fromDate: "",
                toDate: "",
            };
            this.loading = false;
        },
    },
    async mounted() {
        this.loading = true;
        await this.$store.dispatch(
            "order/getOrderDetails",
            this.$route.params.orderId,
        );
        const payload = {
            customerId: this.orderDetailsData.customer?._id,
            fromDate: "",
            toDate: "",
        };
        await this.$store.dispatch("customerManagement/orderGraph", payload);
        this.loading = false;
        await this.$store.dispatch("tenant/fetchTenantSubAdminList", {
            limit: 30,
            page: 1,
        });
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
            }
        },
        formateString(value) {
            if (value) {
                return (
                    value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
                );
            }
        },
    },
};
</script>

<style scoped>
.card {
    border-width: inherit;
    border-radius: 2px;
    box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

[col-4="image"] {
    background-color: aliceblue !important;
}

[btn-back="primary"] {
    background-color: var(--primary) !important;
    margin: 0px;
    height: 41px;
    color: white;
}
</style>
<style>
.footer-bottons-class {
    text-align: center;
    background: var(--primary) !important;
    margin-left: 40%;
}

.span-text {
    font-size: 14px;
    font-weight: normal;
    color: #000000;
    padding-top: 10px;
}
.order-color {
    font-size: 16px;
    color: #2726c1;
}
.h5-text {
    font-size: 14px;
    line-height: 10px;
}

.card-span-text {
    font-size: 14px;
    color: #000000;
    font-weight: normal;
    line-height: 17px;
}
.badge-danger {
    color: #fff;
    background-color: #faae5c;
}
.boxstyle {
    border-radius: 10px;
    border: 1px solid #dce2e7;
    background-color: #ffffff;
}
.align-right {
    text-align: end;
}
.bg-change {
    background-color: #00dfff;
}
.dot {
    height: 13px;
    width: 13px;
    margin: 2px 14px 0px -1px;
    background-color: #00b512;
    border-radius: 50%;
    display: inline-block;
}
.lastDot {
    height: 12px;
    width: 12px;
    margin: 0px 3px 0px 0px;
    background-color: #dbe4e1;
    border-radius: 50%;
    display: inline-block;
}
.verticalLine {
    border-left: 2px dashed rgb(35, 192, 35);
    padding: 6px 0px;
    height: auto;
    position: relative;
    left: 1%;
    margin-left: -3px;
    top: 0;
}
.deliveredLine {
    padding: 6px 8px;
}
.cancelledDot {
    height: 12px;
    width: 12px;
    margin: 2px 3px 2px 0px;
    border-radius: 50%;
    display: inline-block;
    background-color: #ff2f2f;
}
.table-heading {
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    text-transform: capitalize;
    color: #000000;
}
.shipping-charge {
    color: #42b039;
}
.button-invoice {
    background: #ff9900;
    color: white;
    font-size: 13px;
}
.modal-title {
    font-style: normal;
    font-weight: 600;
    font-size: 20px !important;
    line-height: 24px;
    color: #403fe0 !important;
}

.cancel-button {
    box-sizing: border-box;
    color: #403fe0;
    background: #ffffff;
    border: 1px solid #403fe0;
    border-radius: 4px;
}
.pill-alignment {
    padding-left: 18px !important;
    padding-right: 25px !important;
}
.span-text-pill {
    font-size: 14px;
    font-weight: normal;
    padding-top: 10px;
}
.not-selfpick {
    background: rgba(14, 0, 102, 0.31) !important;
    border: 1px solid #0e0066 !important;
    border-radius: 20px !important;
    color: #0e0066 !important;
}
.self-pick {
    background: rgba(221, 64, 95, 0.31);
    border: 1px solid #dd405f;
    border-radius: 20px;
    color: #dd405f;
}
.pill-paymentType {
    background: #ffe6eb !important;
    border: 1px solid #dd405f !important;
    border-radius: 20px !important;
    color: #dd405f !important;
}
.pill-payment-status {
    background: #d3d2ff;
    border: 1px solid #403fe0;
    border-radius: 20px;
    color: #403fe0;
    width: 100px;
    display: inline-block;
    padding: 6px 0;
    text-align: center;
}
.processing {
    background: #d5ebdb;
    border: 1px solid #34a853;
    border-radius: 20px;
    color: #34a853;
}
.item-type {
    background: rgba(254, 123, 8, 0.31);
    border: 1px solid #fe7b08;
    border-radius: 20px;
    color: #fe7b08;
}
.created {
    background: hsla(286, 87%, 52%, 0.31);
    border: 1px solid #7c128d;
    border-radius: 20px;
    color: #911aa3;
}
.returned {
    background: rgba(8, 254, 16, 0.31);
    border: 1px solid #232708;
    border-radius: 20px;
    color: #232708;
}
.cancelled {
    background: rgb(251, 134, 134);
    border: 1px solid #87291f;
    border-radius: 20px;
    color: #87291f;
}
.delivered {
    background: rgba(179, 238, 120, 0.31);
    border: 1px solid #fe7b08;
    border-radius: 20px;
    color: #fe7b08;
}
.dispatched {
    background: hsla(286, 87%, 52%, 0.31);
    border: 1px solid #7c128d;
    border-radius: 20px;
    color: #911aa3;
}
.created-time {
    font-weight: 500;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0.15px;
    color: #000000;
}
.estimated-time {
    font-weight: 700;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0.15px;

    color: #ed5519;
}
.totalPrice {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-transform: capitalize;
    color: #403fe0;
}
.order-status {
    color: #000000;
}
</style>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
